<div id="ds-slide-wrapper">
    @if (priorityMessages().length) {
    <ds-priority-banner animate.enter="ds-fade-enter" animate.leave="ds-fade-leave" />
    }
    <main animate.enter="ds-fade-enter" animate.leave="ds-fade-leave"
        id="ds-display">
        @if (controller()) {
        <ng-container *ngComponentOutlet="layout(); inputs: inputs()" />
        }
    </main>
</div>
